import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { OrdersService } from '@dss-libs/portal/data-access/contract-order';
import { TranslocoDirective } from '@jsverse/transloco';
import { TranslocoDatePipe, TranslocoDecimalPipe } from '@jsverse/transloco-locale';
import {
  AbstractModalComponent,
  BaseModalComponent,
  ModalListSkeletonComponent,
} from '@dss-libs/shared/ui/common-components';
import { InitialsPipe } from '@dss-libs/shared/ui/common-pipes';
import { MatIconModule } from '@angular/material/icon';
import {
  TOrderStatusModalData,
  recipientActionStatusMapper,
  RecipientActionTranslationMapper,
} from '@dss-libs/portal/type/portal-types';

@Component({
  selector: 'dss-libs-feature-order-status-modal',
  imports: [
    BaseModalComponent,
    TranslocoDirective,
    TranslocoDatePipe,
    TranslocoDecimalPipe,
    MatIconModule,
    InitialsPipe,
    ModalListSkeletonComponent,
  ],
  templateUrl: './order-status-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [TranslocoDatePipe, TranslocoDecimalPipe],
})
export class OrderStatusModalComponent extends AbstractModalComponent<TOrderStatusModalData> {
  readonly #contractOrderService = inject(OrdersService);
  readonly #orderId = signal(this.dialogData!.orderId);
  protected readonly recipientActionTranslationKey = RecipientActionTranslationMapper;
  protected readonly recipientActionStatusMapper = recipientActionStatusMapper;
  protected readonly orderStatusDetailsResource = this.#contractOrderService.orderStatusDetailsResource(this.#orderId);

  protected readonly orderStatusDetails = computed(() =>
    this.orderStatusDetailsResource.hasValue() ? this.orderStatusDetailsResource.value() : []
  );
}
